import React from 'react';

const AttendanceForm = ({ form, formError, onChange, onSubmit, onCancel, isEdit, students }) => (
  <form onSubmit={onSubmit} className="modal-form" autoComplete="off">
    <select
      value={form.student || ''}
      onChange={e => onChange('student', e.target.value)}
      required
      className="modal-form-select"
    >
      <option value="" disabled>Select Student</option>
      {students && students.map(s => (
        <option key={s._id} value={s._id}>
          {s.name} - Class {s.class}{s.section ? ` (${s.section})` : ''}
        </option>
      ))}
    </select>

    <input
      type="date"
      value={form.date || ''}
      onChange={e => onChange('date', e.target.value)}
      required
      className="modal-form-input"
    />

    <select
      value={form.status || ''}
      onChange={e => onChange('status', e.target.value)}
      required
      className="modal-form-select"
    >
      <option value="" disabled>Select Status</option>
      <option value="Present">Present</option>
      <option value="Absent">Absent</option>
      <option value="Late">Late</option>
      <option value="Excused">Excused</option>
    </select>

    <textarea
      placeholder="Remarks (optional)"
      value={form.remarks || ''}
      onChange={e => onChange('remarks', e.target.value)}
      className="modal-form-textarea"
      rows="3"
    />

    <div className="modal-actions">
      <button type="submit">{isEdit ? 'Update' : 'Add'}</button>
      <button type="button" onClick={onCancel}>Cancel</button>
    </div>
    {formError && <div className="error">{formError}</div>}
  </form>
);

export default AttendanceForm;
